
import { useSelector } from 'react-redux';

import Paper from '@mui/material/Paper';
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import TableFooter from "@mui/material/TableFooter";
    
const ProductTable = ({data}) => {
    const {dashboardLoaders} = useSelector(state => state.dashboardReducer);


    const headerStyle = { fontWeight: "bold", };
    const productItemHeaderStyle = {
        padding: "5px 16px",
        fontWeight: "bold",
        lineHeight: 'inherit'
        
    };
    const productItemStyle = {  padding: "5px 16px" };
    
    const surchargeRightStyle = {
        fontWeight: "bold",
        textAlign: "right",
    };

    return (
        <TableContainer component={Paper}>
            <Table size="small" aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell
                            style={productItemHeaderStyle}
                            align="left"
                        >
                            Product Code
                        </TableCell>
                        <TableCell
                            style={productItemHeaderStyle}
                            align="left"
                        >
                            Product Title
                        </TableCell>
                        <TableCell
                            style={productItemHeaderStyle}
                            align="right"
                        >
                            Hire Period
                        </TableCell>
                        <TableCell
                            style={productItemHeaderStyle}
                            align="right"
                        >
                            Quantity
                        </TableCell>
                        <TableCell
                            style={productItemHeaderStyle}
                            align="right"
                        >
                            Item Price
                        </TableCell>
                        <TableCell
                            style={productItemHeaderStyle}
                            align="right"
                        >
                            Weekly Price
                        </TableCell>
                        <TableCell
                            style={productItemHeaderStyle}
                            align="right"
                        >
                            Weeks Charged
                        </TableCell>
                        <TableCell
                            style={productItemHeaderStyle}
                            align="right"
                        >
                            Total
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data && data.order_items
                        ? data.order_items.map((row) => (
                                <TableRow key={row.ID}>
                                    <TableCell
                                        style={productItemStyle}
                                        align="left"
                                    >
                                        {row.ProductCodeShort}
                                    </TableCell>
                                    <TableCell
                                        style={productItemStyle}
                                        component="th"
                                        align="left"
                                        scope="row"
                                    >
                                        {row.ProductTitle}
                                    </TableCell>
                                    <TableCell
                                        style={productItemStyle}
                                        align="right"
                                    >
                                        {row.HirePeriod}
                                    </TableCell>
                                    <TableCell
                                        style={productItemStyle}
                                        align="right"
                                    >
                                    {row.Quantity}
                                    </TableCell>
                                    <TableCell
                                        style={productItemStyle}
                                        align="right"
                                    >
                                        {row.UnitPrice}
                                    </TableCell>
                                    <TableCell
                                        style={productItemStyle}
                                        align="right"
                                    >
                                        {row.WeeklyPrice}
                                    </TableCell>
                                    <TableCell
                                        style={productItemStyle}
                                        align="right"
                                    >
                                        {row.BilledWeeks}
                                    </TableCell>
                                    <TableCell
                                        style={productItemStyle}
                                        align="right"
                                    >
                                        {row.ItemTotal}
                                    </TableCell>
                                </TableRow>
                            ))
                        : null}
                </TableBody>
                <TableFooter>
                        <TableRow>
                            <TableCell colSpan={8} style={surchargeRightStyle}>
                                {data.order_product_total}
                            </TableCell>
                        </TableRow>
                </TableFooter>
            </Table>
        </TableContainer>
    )
}

export default ProductTable